import {useContext} from 'react';
import ExperienceContext, {
  ExperienceContextProps,
} from '@/contexts/experienceContext';

const useExperienceContext = (): ExperienceContextProps => {
  const context = useContext(ExperienceContext);

  if (!context) {
    throw new Error(
      'useExperienceContext must be used within an ExperienceContextProvider',
    );
  }

  return context;
};

export default useExperienceContext;
